module.exports = __webpack_public_path__ + "media/images/app/become-vendor/prob3-9dfb21003ee3c6344fa16c58f7d2fc69.webp";